module.exports = __webpack_public_path__ + "static/media/228GR.ac2449d1.jpg";